// Snippet processor — orchestrates all structural content snippets recursively.
//
// Processing order (outermost → innermost):
//   1. width      — outermost wrapper
//   2. toggle     — collapsible sections
//   3. reveal-answer / interactive-reveal-answer — quiz blocks
//   4. icon blocks + grid — innermost structural elements
//   5. tooltip references — inline, runs after structure is stable
//
// Circular-import prevention: each processor receives `processAllSnippets` as a
// `recurse` callback instead of importing it directly.

import { processWidthBlocks }                    from './width-processor.js';
import { processFaqBlocks }                      from './faq.js';
import { processToggleBlocks }                   from './toggle.js';
import { processRevealAnswerBlocks }             from './reveal-answer.js';
import { processInteractiveRevealAnswerBlocks }  from './interactive-reveal-answer.js';
import { processSnippetBlock }                   from './content-snippets.js';
import { processCompareSliderBlocks }            from './compare-slider.js';
import { processTooltipReferences }              from './footnotes.js';

/**
 * Process all snippet types inside `container`, recursively.
 * Safe to call on any element — post root, toggle content, width wrapper, etc.
 *
 * @param {Element} container
 * @param {Map}     footnotesMap
 */
export function processAllSnippets(container, footnotesMap) {
  if (!container) return;

  processWidthBlocks(container, footnotesMap, processAllSnippets);
  processFaqBlocks(container, footnotesMap, processAllSnippets);
  processToggleBlocks(container, footnotesMap, processAllSnippets);
  processRevealAnswerBlocks(container, footnotesMap);
  processInteractiveRevealAnswerBlocks(container, footnotesMap);
  processCompareSliderBlocks(container);
  processSnippetBlock(container, footnotesMap, processAllSnippets);
  processTooltipReferences(container, footnotesMap);
}
